// extracted by mini-css-extract-plugin
export default {"checkBoxContainer":"CheckBox_checkBoxContainer__GdStF","container":"CheckBox_container__Qvzea","checkmark":"CheckBox_checkmark__mAQnW","label":"CheckBox_label__g3oH4"};